/** Campos — Evaluación Inicial (Integración Sensorial, formato amplio) */

import {
  TIPO_CAMPO,
  CAMPOS_DATOS_GENERALES,
  CAMPOS_ANTECEDENTES,
  CAMPOS_MOTRICIDAD_FINA,
  CAMPOS_MOTRICIDAD_GRUESA,
  CAMPOS_CIERRE,
} from "./camposEvalInicial";

export {
  TIPO_CAMPO,
  CAMPOS_DATOS_GENERALES,
  CAMPOS_ANTECEDENTES,
  CAMPOS_MOTRICIDAD_FINA,
  CAMPOS_MOTRICIDAD_GRUESA,
  CAMPOS_CIERRE,
};

const TC = TIPO_CAMPO;

export const CAMPOS_AVD = [
  { key: "vestido", label: "Vestido", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "higiene", label: "Higiene", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "alimentacion", label: "Alimentación", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
];

export const CAMPOS_AVD_INSTRUMENTALES = [
  { key: "instrumentales", label: "Instrumentales", tipo: TC.MULTILINEA, rows: 3, maxLength: 500 },
];

export const CAMPOS_CONDUCTA = [
  { key: "conducta", label: "Conducta", tipo: TC.MULTILINEA, rows: 4, maxLength: 800 },
];

export const CAMPOS_COGNICION_BASE = [
  { key: "comunicacion", label: "Comunicación", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "percepcion", label: "Percepción", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "atencion", label: "Atención", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "concentracion", label: "Concentración", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  {
    key: "seguimientoIndicaciones",
    label: "Seguimiento de indicaciones",
    tipo: TC.MULTILINEA,
    rows: 2,
    maxLength: 400,
  },
  { key: "memoria", label: "Memoria", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "esquemaCorporal", label: "Esquema corporal", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  {
    key: "relacionesEspaciales",
    label: "Relaciones espaciales",
    tipo: TC.MULTILINEA,
    rows: 2,
    maxLength: 400,
  },
  { key: "colores", label: "Colores", tipo: TC.LINEA, maxLength: 200 },
  { key: "figurasGeometricas", label: "Figuras geométricas", tipo: TC.LINEA, maxLength: 200 },
  { key: "numeros", label: "Números", tipo: TC.LINEA, maxLength: 200 },
  { key: "seguimientoPatrones", label: "Seguimiento de patrones", tipo: TC.LINEA, maxLength: 200 },
  { key: "copia", label: "Copia", tipo: TC.LINEA, maxLength: 200 },
  { key: "cierreVisual", label: "Cierre visual", tipo: TC.LINEA, maxLength: 200 },
  { key: "figuraFondo", label: "Figura a fondo", tipo: TC.LINEA, maxLength: 200 },
  { key: "lectura", label: "Lectura", tipo: TC.LINEA, maxLength: 200 },
  { key: "escritura", label: "Escritura", tipo: TC.LINEA, maxLength: 200 },
  {
    key: "procedimientosMatematicos",
    label: "Procedimientos matemáticos",
    tipo: TC.LINEA,
    maxLength: 200,
  },
  {
    key: "desempenoEscolar",
    label: "Desempeño escolar",
    tipo: TC.MULTILINEA,
    rows: 2,
    maxLength: 400,
  },
];

export const CAMPOS_SENSORIAL_SISTEMAS = [
  { key: "propioceptivo", label: "Propioceptivo", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "vestibular", label: "Vestibular", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "tactil", label: "Táctil", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "auditivo", label: "Auditivo", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "visual", label: "Visual", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "olfato", label: "Olfato", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "gusto", label: "Gusto", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
  { key: "interoceptivo", label: "Interoceptivo", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
];

export const CAMPOS_SOCIAL = [
  { key: "social", label: "Social", tipo: TC.MULTILINEA, rows: 2, maxLength: 400 },
];

export const CAMPOS_OBSERVACIONES = [
  {
    key: "observacionesGenerales",
    label: "Observaciones",
    tipo: TC.MULTILINEA,
    rows: 4,
    maxLength: 800,
  },
];
